import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { UserDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { resetRetrieveUser, retrieveUser } from "./retrieve-user";

const initialState: RetrievalState<UserDetailVM | null> = { fetching: "idle", data: null };

export const retrieveUserReducer = createReducer<RetrievalState<UserDetailVM | null>>(initialState, builder => {
  builder.addCase(retrieveUser.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveUser.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveUser.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetRetrieveUser, () => {
    return initialState;
  });
});
